// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64(),
  worldId: __t.u64().name("world_id"),
  owner: __t.identity(),
  name: __t.string(),
  class: __t.u8(),
  species: __t.u8(),
  build: __t.u8(),
  level: __t.u8(),
  xp: __t.u32(),
  gold: __t.u32(),
  shapeMark: __t.u8().name("shape_mark"),
  oryxFrame: __t.u16().name("oryx_frame"),
  status: __t.u8(),
  activeEncounter: __t.option(__t.u64()).name("active_encounter"),
  cards: __t.array(__t.u16()),
  createdAt: __t.timestamp().name("created_at"),
  fights: __t.u32(),
  victories: __t.u32(),
  finalBlows: __t.u32().name("final_blows"),
  timesDowned: __t.u32().name("times_downed"),
});
